import React from "react";

const RangeActivitySelector = (props) => {
  const handleChangeGte = (value) => {
    if (value == "nil") value = null;
    props.setGte(value);
  };

  const handleChangeLte = (value) => {
    if (value == "nil") value = null;
    props.setLte(value);
  };

  const customItemsGte = (items) => {
    let new_items = items;
    if (props.lte != null) {
      new_items = items.filter((item) => {
        return Number(props.lte) >= Number(item.value);
      });
    }
    return new_items;
  };

  const customItemsLte = (items) => {
    let new_items = items;
    if (props.gte != null) {
      new_items = items.filter((item) => {
        return Number(item.value) >= Number(props.gte);
      });
    }
    return new_items;
  };

  return (
    <div className="selectConditions searchList isRangeActivity">
      <select
        value={props.gte | ""}
        onChange={(e) => handleChangeGte(e.target.value)}
      >
        <option value="nil"> 下限なし </option>
        {customItemsGte(props.items).map((item, index) => {
          return (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </select>
      <span>〜</span>
      <select
        value={props.lte | ""}
        onChange={(e) => handleChangeLte(e.target.value)}
      >
        <option value="nil"> 上限なし </option>
        {customItemsLte(props.items).map((item, index) => {
          return (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default RangeActivitySelector;
